<template>
  <div class="chargeslist">
    <div
      class="chargesitem"
      v-for="(item, index) in intlist"
      :key="index"
      @mouseover="active = index"
      @click="tojump(item, 0)"
      :class="{ itemactiv: active == index }"
    >
      <div class="cli1 ellipsis">
        {{ item.title }}
      </div>
      <div class="cli2">
        {{ item.gain | toEllipsisFilter(110) }}
      </div>
      <div class="cli3 flex_start" v-show="active == index">
        <div @click.stop="tojump(item, 1)">概念</div>
        <div @click.stop="tojump(item, 2)">构成要件</div>
        <div @click.stop="tojump(item, 3)">认定</div>
        <div @click.stop="tojump(item, 4)">立案标准</div>
        <div @click.stop="tojump(item, 5)">量刑标准</div>
        <div @click.stop="tojump(item, 6)">司法解释</div>
        <div @click.stop="tojump(item, 7)">法律意见</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    intlist: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    active: 0,
  }),
  methods: {
    tojump(item, pageid) {
      console.log("点击了跳转", pageid);
       this.$router.push({
          path: "/jpcol/zuimindetail",
          query: {
            artid: item.id,
          },
        });
      this.$store.commit('jpcol/upzmId',pageid)
      
    },
  },
};
</script>

<style lang="scss" scoped>
.chargeslist {
  .chargesitem {
    border-bottom: 1px solid #eee;
    cursor: pointer;
    padding: 24px 0;
    .cli1 {
      font-size: 18px;
      line-height: 18px;
      color: #333333;
    }
    .cli2 {
      margin-top: 12px;
      font-size: 14px;
      color: #666666;
      line-height: 25px;
    }
    .cli3 {
      margin-top: 14px;
      div {
        cursor: pointer;
        width: 84px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        background: #f3f8ff;
        border-radius: 13px;
        font-size: 14px;
        color: #0465ea;
        margin-right: 20px;
        &:hover {
          background: #0465ea;
          color: #fff;
        }
      }
    }
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>